import { onBeforeUnmount, onMounted } from "vue";
import type Alert from "@/interfaces/Alerts/Alert";
import { AlertType } from "@/enumerations/Alerts/AlertType";
import router from "@/router";
import { SESSION_CHANGED_IN_ANOTHER_TAB_MESSAGE } from "@/services/httpClient";
import { useAlertsStore } from "@/stores/alerts";
import { useAuthStore } from "@/stores/auth";

// A tab kept logged in follows a sign-out, or another login's sign-in, in another tab.
export async function followSessionChangeInAnotherTab(event: StorageEvent) {
  if (!useAuthStore().endSessionSignedOutInAnotherTab(event)) {
    return;
  }

  useAlertsStore().setAlert({
    headerMessage: SESSION_CHANGED_IN_ANOTHER_TAB_MESSAGE,
    bodyMessage: "",
    type: AlertType.Information,
  } as Alert);
  await router.push("/login");
}

export function useSessionFromOtherTabs() {
  onMounted(() => window.addEventListener("storage", followSessionChangeInAnotherTab));
  onBeforeUnmount(() => window.removeEventListener("storage", followSessionChangeInAnotherTab));
}
